<ng-container *appTranslate="let t">
  @if (showOutgoingTab || showIncomingTab) {
    <new-ui-dashboard-card>
      <ng-template #header>
        <new-ui-dashboard-card-header [title]="t('dashboard.talentPoolRequests.title')" />
      </ng-template>

      @defer (when requests()) {
        <p-tabs class="min-w-fit" [value]="defaultTab">
          <p-tablist class="min-w-fit">
            @if (showOutgoingTab) {
              <p-tab value="0">{{ t("dashboard.talentPoolRequests.outgoing.title") }}</p-tab>
            }
            @if (showIncomingTab) {
              <p-tab value="1">{{ t("dashboard.talentPoolRequests.incoming.title") }}</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            @if (showOutgoingTab) {
              <p-tabpanel value="0">
                @if (requests().outgoing?.length > 0) {
                  <new-ui-dashboard-list [values]="requests().outgoing" />
                } @else {
                  <ui-emptystate
                    class="py-[3%]"
                    image="/assets/layout/images/new-ui/search.png"
                    [caption]="t('dashboard.talentPoolRequests.outgoing.emptyState.title')"
                    [description]="t('dashboard.talentPoolRequests.outgoing.emptyState.description')"
                  />
                }
              </p-tabpanel>
            }
            @if (showIncomingTab) {
              <p-tabpanel value="1">
                @if (requests().incoming?.length > 0) {
                  <new-ui-dashboard-list [values]="requests().incoming" />
                } @else {
                  <ui-emptystate
                    class="py-[3%]"
                    image="/assets/layout/images/new-ui/search.png"
                    [caption]="t('dashboard.talentPoolRequests.incoming.emptyState.title')"
                    [description]="t('dashboard.talentPoolRequests.incoming.emptyState.description')"
                  />
                }
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      } @placeholder {
        <ul class="col gap-4 p-0 pr-2">
          @for (item of [1, 2, 3]; track item) {
            <li class="flex flex-col mobile:flex-row gap-4 p-2 border border-surface-border rounded-lg shadow-sm">
              <div class="basis-1/2 row gap-2">
                <p-skeleton shape="circle" size="1.25rem" />
                <p-skeleton class="h-5 w-40" />
              </div>
              <div class="basis-1/2 row gap-2">
                <p-skeleton shape="circle" size="1rem" />
                <p-skeleton class="h-5 w-24" />
              </div>
            </li>
          }
        </ul>
      }
    </new-ui-dashboard-card>
  }
</ng-container>
